export default __webpack_public_path__ + "static/media/Solid_white.0edc209b.svg";